import { ProductCategoryUpdatePage } from "@/features/product-category/pages/ProductCategoryUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-category/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductCategoryUpdatePage,
});
